import { Button, Card, FormControlLabel, Switch, TextField } from '@mui/material';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { packageHandler } from '../../../redux/handlers';
import { DeleteConfirmModal } from '../modals/DeleteConfirmModal';
import { PackageSuccessModal } from '../modals/PackageSuccessModal';

export function PackageAddOnTab() {
  const { packageID } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState([]);
  const [actionType, setActionType] = useState('create');
  const [initialFormData, setInitialFormData] = useState({
    name: '',
    price_month: '',
    price_year: '',
    permissions: {},
    packageAdditionalPermissions: []
  });

  const [modalCreateSuccess, setModalCreateSuccess] = useState({
    open: false,
    x: 0,
    y: 0,
    width: 460,
    height: 350,
    pin: false,
    mode: 'normal',
    modalname: 'create'
  });

  const [modalDeleteConfirm, setModalDeleteConfirm] = useState({
    open: false,
    x: 0,
    y: 0,
    width: 460,
    height: 350,
    pin: false,
    mode: 'normal',
    modalname: 'delete'
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const permissionsResult = await dispatch(packageHandler.getPermissions('ADDITIONAL'));
        if (permissionsResult) {
          setPermissions(permissionsResult);
        }

        console.log('permissionsResult : ', permissionsResult);

        if (packageID) {
          const packageResult = await dispatch(packageHandler.getPackageById(packageID));

          if (packageResult) {
            const formattedPermissions = {};

            packageResult.packageAdditionalPermissions.forEach(additionalPerm => {
              console.log('additionalPerm : ', additionalPerm);

              formattedPermissions[additionalPerm.permission_id] = {
                price_month: additionalPerm?.permission?.permission?.price_per_month,
                price_year: additionalPerm?.permission?.permission?.price_per_year,
                is_not_show_customer: additionalPerm?.permission?.permission?.is_not_show_customer
              };
            });

            console.log('formattedPermissions : ', formattedPermissions);

            setInitialFormData({
              name: packageResult.name,
              price_month: packageResult.price_month?.toString(),
              price_year: packageResult.price_year?.toString(),
              permissions: formattedPermissions,
              packageAdditionalPermissions: packageResult.packageAdditionalPermissions
            });
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [dispatch, packageID]);

  const transformPermission = (permission, values, packageAdditionalPermissions = []) => {
    const currentPermission = values.permissions[permission.id] || {};
    const existingPermission = packageAdditionalPermissions.find(p => p.permission_id === permission.id);

    return {
      id: existingPermission?.id,
      permission_id: permission.id,
      permission: {
        type: permission.permissionCode || permission.type, // ใส่ type ที่ Backend ต้องการ
        permission: {
          price_per_month: Number(currentPermission.price_month || 0),
          price_per_year: Number(currentPermission.price_year || 0),
          is_not_show_customer: currentPermission.is_not_show_customer || false
        }
      }
    };
  };

  const transformFormToApiData = (values, permissions, packageAdditionalPermissions = []) => {
    const transformedPermissions = permissions
      .map(perm => transformPermission(perm, values, packageAdditionalPermissions))
      .filter(permission => {
        // แก้ไขเงื่อนไขการกรอง - ใช้ permission.permission_id แทน perm.id
        const currentPermission = values.permissions[permission.permission_id] || {};
        const hasPrice = currentPermission.price_month > 0 || currentPermission.price_year > 0;
        const hasToggle = currentPermission.is_not_show_customer;

        // ส่งไปถ้ามีการตั้งราคาหรือมีการเปิด toggle
        return hasPrice || hasToggle;
      });

    return {
      permissions: transformedPermissions
    };
  };

  const handleSubmit = async values => {
    try {
      const requestData = transformFormToApiData(
        values,
        permissions,
        packageID ? initialFormData.packageAdditionalPermissions : []
      );

      let result;
      if (packageID) {
        setActionType('update');
        result = await dispatch(packageHandler.updateAdditionalPermission(packageID, requestData));
      } else {
        setActionType('create');
        result = await dispatch(packageHandler.createPackage(requestData));
      }
      if (result) {
        setModalCreateSuccess({
          ...modalCreateSuccess,
          open: true
        });
        setTimeout(() => {
          setModalCreateSuccess({
            ...modalCreateSuccess,
            open: false
          });
          navigate('/packages');
        }, 1000);
      }
    } catch (error) {
      console.error(packageID ? 'Failed to update package:' : 'Failed to create package:', error);
    }
  };

  const handleDelete = async () => {
    try {
      setActionType('delete');
      let result = await dispatch(packageHandler.deletePackage(packageID));
      if (result) {
        setModalCreateSuccess({
          ...modalCreateSuccess,
          open: true
        });
        setTimeout(() => {
          setModalCreateSuccess({
            ...modalCreateSuccess,
            open: false
          });
          navigate('/packages');
        }, 1000);
      }
    } catch (error) {
      console.error('Failed to delete package:', error);
    }
  };

  const handleRemove = () => {
    setModalDeleteConfirm({
      ...modalDeleteConfirm,
      open: true
    });
  };

  const renderPermission = (permission, values, setFieldValue) => (
    <div
      key={permission.id}
      className="flex items-center px-4 py-2 border-b-[1px] border-[#4C4E64]/[0.12] text-[#4C4E64]/[0.87]"
    >
      <div className="w-[375px]">{permission.permissionName}</div>
      <div className="w-[200px]">
        <TextField
          label=""
          variant="outlined"
          InputProps={{ sx: { borderRadius: '7px' } }}
          fullWidth
          onChange={e => {
            const value = e.target.value;
            if (value === '' || /^\d+$/.test(value)) {
              setFieldValue(`permissions.${permission.id}.price_month`, value);
            }
          }}
          name={`permissions.${permission.id}.price_month`}
          value={values?.permissions?.[permission.id]?.price_month || ''}
          type="text"
          inputProps={{
            pattern: '[0-9]*',
            inputMode: 'numeric'
          }}
        />
      </div>
      <div className="pl-3 pr-5">/บาท</div>
      <div>
        <FormControlLabel
          control={<Switch />}
          label="ไม่แสดงในฝั่งลูกค้า"
          checked={values?.permissions?.[permission.id]?.is_not_show_customer || false}
          onChange={e => setFieldValue(`permissions.${permission.id}.is_not_show_customer`, e.target.checked)}
        />
      </div>
    </div>
  );

  return (
    <>
      <Card className="!rounded-lg mb-4">
        <div className="p-4">
          <div className="text-[#4C4E64] font-semibold text-xl mb-4">{packageID ? 'แก้ไขแพ็คเกจ' : 'สร้างแพ็คเกจ'}</div>
          <Formik enableReinitialize initialValues={initialFormData} onSubmit={handleSubmit}>
            {({ handleSubmit, handleChange, values, setFieldValue }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <div className="grid grid-cols-12 gap-4 items-center mb-7">
                  <div className="md:col-span-6 col-span-12">
                    <TextField
                      label="ชื่อแพ็คเกจ*"
                      variant="outlined"
                      InputProps={{ sx: { borderRadius: '7px' } }}
                      fullWidth
                      disabled
                      onChange={handleChange}
                      name="name"
                      value={values?.name || ''}
                    />
                  </div>
                  <div className="md:col-span-3 col-span-6">
                    <TextField
                      label="ราคาแพ็คเกจ (รายเดือน)"
                      variant="outlined"
                      InputProps={{ sx: { borderRadius: '7px' } }}
                      fullWidth
                      disabled
                      onChange={handleChange}
                      name="price_month"
                      value={values?.price_month || ''}
                    />
                  </div>
                  <div className="md:col-span-3 col-span-6">
                    <TextField
                      label="ราคาแพ็คเกจ (รายปี)"
                      variant="outlined"
                      InputProps={{ sx: { borderRadius: '7px' } }}
                      fullWidth
                      disabled
                      onChange={handleChange}
                      name="price_year"
                      value={values?.price_year || ''}
                    />
                  </div>
                </div>

                <div className="text-[#4C4E64] font-semibold text-lg p-4">ตั้งค่าแพ็คเกจเสริม</div>

                <div className="bg-[#4C4E64]/[0.12] text-[#4C4E64]/[0.87] px-4 py-3">คุณสมบัติพื้นฐาน</div>
                {permissions.map(permission => renderPermission(permission, values, setFieldValue))}

                <div className="flex justify-between mt-4">
                  {packageID && (
                    <Button
                      type="button"
                      className="btn-st-5 me-3 !bg-[#F95057] !rounded-lg !text-[#FFFFFF]"
                      variant="outlined"
                      onClick={handleRemove}
                    >
                      ลบ
                    </Button>
                  )}
                  <div className="flex justify-end w-full">
                    <Button
                      type="submit"
                      className="btn-st-3 !bg-[#409FFB] !rounded-lg !text-white"
                      variant="contained"
                    >
                      บันทึก
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Card>
      <DeleteConfirmModal modal={modalDeleteConfirm} setModal={setModalDeleteConfirm} onConfirm={handleDelete} />
      <PackageSuccessModal modal={modalCreateSuccess} setModal={setModalCreateSuccess} type={actionType} />
    </>
  );
}
